// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-migrate-to-workbook-dialog-entry-row {
  display: flex;
  align-items: center;
}
.dl-migrate-to-workbook-dialog-entry-row__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}
.dl-migrate-to-workbook-dialog-entry-row__name {
  margin-left: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--g-color-text-primary);
  -webkit-text-decoration: none;
  text-decoration: none;
}
.dl-migrate-to-workbook-dialog-entry-row__warning {
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.dl-migrate-to-workbook-dialog-entry-row__warning-text {
  margin-left: 8px;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/MigrateToWorkbookDialog/components/EntryRow/EntryRow.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AACR;AAEI;EACI,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;EACA,6BAAA;EAAA,qBAAA;AAAR;AAGI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AADR;AAII;EACI,gBAAA;EACA,mBAAA;AAFR","sourcesContent":[".dl-migrate-to-workbook-dialog-entry-row {\n  display: flex;\n  align-items: center;\n}\n.dl-migrate-to-workbook-dialog-entry-row__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n}\n.dl-migrate-to-workbook-dialog-entry-row__name {\n  margin-left: 8px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: var(--g-color-text-primary);\n  text-decoration: none;\n}\n.dl-migrate-to-workbook-dialog-entry-row__warning {\n  display: flex;\n  align-items: center;\n  margin-left: 8px;\n}\n.dl-migrate-to-workbook-dialog-entry-row__warning-text {\n  margin-left: 8px;\n  white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
